<template>
  <div class="b2c-warm-tips">
    <div class="b2c-warm-tips__content">
      <div class="b2c-warm-tips__content__title">温馨提示</div>
      <div class="b2c-warm-tips__content__content">
        <div
          v-for="item in qualityTipsMsg"
          :key="item.text"
          class="b2c-warm-tips__content__content__item"
        >
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-html="translateToHtml(item.tiShiText)"></span>
          <span v-if="item.desc" class="explain-text" @click="openInfoDialog(item)">{{
            item.desc
          }}</span>
        </div>
      </div>
    </div>

    <!-- 服务弹窗 -->
    <info-dialog ref="deliveryDialogRef" :title="infoDialogTitle" :infoData="infoDialogData" />
  </div>
</template>

<script>
  import infoDialog from './info-dialog'
  export default {
    components: {
      infoDialog,
    },
    props: {
      qualityTipsMsg: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        infoDialogTitle: '',
        infoDialogData: null,
      }
    },

    methods: {
      openInfoDialog(item) {
        this.infoDialogTitle = item.title
        this.infoDialogData = item.itemInfos
        this.$refs.deliveryDialogRef && this.$refs.deliveryDialogRef.open()
      },
      translateToHtml(str) {
        const regex = /<([^<>]+)>/g
        const replacedStr = str.replace(regex, '<span style="font-weight: 500;">$1</span>')
        return replacedStr
      },
    },
  }
</script>

<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  .b2c-warm-tips {
    width: 686px;
    // height: 290px;
    margin: 16px 32px 0 32px;

    border-radius: 16px;
    box-sizing: border-box;
    padding: 36px 44px 36px 44px;
    border: 1px solid #f0f0f0;
    background: #fff;

    &__content {
      &__title {
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #111111;
        line-height: 28px;
      }
      &__content {
        margin-top: 30px;

        &__item {
          width: 598px;
          // height: 90px;
          font-size: 20px;
          margin-bottom: 10px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 300;
          color: #666666;
          line-height: 30px;

          .explain-text {
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 300;
            color: #666666;
            line-height: 20px;
            position: relative;

            &::after {
              @include hairline(#666);
              border-bottom-width: 1px;
              top: calc(-50% - 6px);
            }
          }
        }
      }
    }
  }
</style>
